module.exports = __webpack_public_path__ + "img/BOD-msg.4aa950cb.jpg";